import { useState, useEffect, useContext } from "react";
import { AppContext } from "../../context/app";
import {
  BaSeButton,
  BaSeHeading2,
  BaSeHeading4,
  BaSeParagraph,
  BaSeShapeButton,
} from "@base/react";
import "./index.scss";
import {eventTag, getCurrentCNPJ, isEqual} from "../../services/utils";
import ApiAuth from "../../services/auth";
import {clearCompaniesCache, setCompaniesCache} from "../../services/companiesCache";

const event = {
  name: "company",
  category: "selecao_de_empresa",
  action: "click",
}

const timeInterval = 3000

const FloatingMenu = ({ onClose }) => {
  const location = window.location.host;
  const protocol = window.location.protocol;
  const { companies, setCompanies, toggleCompanies } = useContext(AppContext);
  const [selectedCnpj, setSelectedCnpj] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [pollingId, setPollingId] = useState(null);

  useEffect(() => {
    const company = getCurrentCNPJ(companies) || null;
    setSelectedCnpj(company)

    setTimeout(() => setModalOpen(true), 10);

    // eslint-disable-next-line
  }, []);

  const handleRegisterCompany = () => {
    eventTag(event?.name, event?.category, event?.action, "Cadastrar nova empresa")
    const url = `${process.env.REACT_APP_CPE}/?voltar=${protocol}//${location}/`;
    clearCompaniesCache()
    window.open(url, "_blank")

    const id = setInterval(() => {
      getCompanies()
    }, timeInterval);

    setPollingId(id);
  };

  const handleClose = () => {
    setModalOpen(false);
    setTimeout(() => onClose(), 300)

    if (pollingId) {
      clearInterval(pollingId);
      setPollingId(null);
    }

    setTimeout(() => onClose(), 300);
  };

  const [actives, inactives] = companies.reduce(
    ([active, inactive], item) => {
      item.isActive ? active.push(item) : inactive.push(item);
      return [active, inactive];
    },
    [[], []]
  )

  const getCompanies = () => {
    const company = getCurrentCNPJ(companies) || null;

    ApiAuth()
      .getCompanies()
      .then((res) => {
        let { data } = res;

        const newData = data.company_list.map((item) => {
          return {
            ...item,
            isActive: company === item.cnpj,
          };
        })
        if (!isEqual(newData, companies)) {
          setCompanies(newData)
          setCompaniesCache(newData);

          if (company) {
            toggleCompanies(company)
          }
        }
      })
      .catch((err) => {
        console.warn(err)
        clearCompaniesCache()
      })
  }

  return (
    <div className="floating-menu-backdrop" onClick={handleClose}>
      <div
        className={`floating-menu-modal ${modalOpen ? "open" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="floating-menu-header">
          <BaSeHeading2 isBold color="#617385">
            Alterar minha empresa
          </BaSeHeading2>
          <BaSeParagraph color="#617385">Selecione a empresa:</BaSeParagraph>
          <button className="close-btn" onClick={handleClose}>
            ×
          </button>
        </div>

        <hr className="full-divider" />

        <div className="company-list">
          {[...actives, ...inactives].map((item, index) => (
            <div
              key={index}
              className={`company-card ${item.isActive ? "active" : ""} ${
                !item.isActive && selectedCnpj === item.cnpj ? "selected" : ""
              }`}
              onClick={() => {
                setSelectedCnpj(item.cnpj)
                eventTag(event?.name, event?.category, event?.action, "Selecionar empresa")
              }}
            >
              <div className="company-info">
                <BaSeHeading4 color="#617385" isBold>
                  {item.name}
                </BaSeHeading4>
                <p>
                  {item.cnpj.replace(
                    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    "$1.$2.$3/$4-$5"
                  )}
                </p>
              </div>
            </div>
          ))}

          <div className="add-company-card" onClick={handleRegisterCompany}>
            <div className="plus-icon">
              <BaSeShapeButton
                buttonType="button"
                color="default"
                nameIcon="character/nunito/plus"
                shape="square"
                size="small"
                sizeIcon="small"
                type="secondary"
              />
            </div>
            <span>Cadastrar nova empresa</span>
          </div>
        </div>

        <div className="floating-menu-footer">
          <div className="cancel-btn">
            <BaSeButton
              type="secondary"
              value="Cancelar"
              className="cancel-btn"
              onClick={handleClose}
              isBold
            />
          </div>
          <div className="confirm-btn">
            <BaSeButton
              isBold
              value="Confirmar"
              className="confirm-btn"
              onClick={() => {
                if (selectedCnpj) {
                  toggleCompanies(selectedCnpj);
                  handleClose();
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloatingMenu;
